import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useTranslation } from 'react-i18next'
import { EditClientForm } from '@/features/Client/EditClientForm/ui/EditClientForm'

type EditClientModalProps = {
  dialogProps: AlertDialogProps
  currentClientId: number
  onCloseModal: () => void
}

export const EditClientModal: FC<EditClientModalProps> = props => {
  const { dialogProps, currentClientId, onCloseModal } = props
  const { t } = useTranslation(['client'])

  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('client:edit_client_modal_title')}</DialogTitle>
          <EditClientForm currentClientId={currentClientId} onCloseModal={onCloseModal} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
